import { APPLICATION_NAMES } from '@mote/helpers/constants'
import { getApplicationKey } from './getApplicationKey'

export const getApplicationName = (url?: string): string => {
  const key = getApplicationKey(url)

  return key ? APPLICATION_NAMES[key] : ''
}
